export function randomNum(lowerValue, upperValue) {
    const maxNum = typeof upperValue === 'number' ? upperValue : parseInt(upperValue, 10);
    const minNum = typeof lowerValue === 'number' ? lowerValue : parseInt(lowerValue, 10);
    return Math.floor(Math.random() * (maxNum - minNum + 1) + minNum);
}
